// extracted by extract-css-chunks-webpack-plugin
module.exports = {"buttonWrapper":"app-components-base-loadmorebutton--buttonWrapper","noPad":"app-components-base-loadmorebutton--noPad"};